import React from 'react';
import { SimpleGrid } from '@chakra-ui/react';

import Typography from '../Typography';

import { Flex } from '../UI/Flex';

import DoctorIcon from '../Icons/DoctorIcon';
import PillsIcon from '../Icons/PillsIcon';
import UserIcon from '../Icons/UserIcon';

import { useIsMobile } from 'src/helpers/useIsMobile';

import HistoricIcon from '../Icons/HistoricIcon';
import { usePrescriberContext } from 'src/providers/PrescriberProvider';
import ShareIcon from '../Icons/ShareIcon';
import { SidebarButton } from './SidebarButton';
import {
  trackSideMenuAssistantClick,
  trackSideMenuHistoryClick,
  trackSideMenuPrescriptionClick,
  trackSideMenuProfileClick,
} from 'src/services/tracking/events';

interface SidebarProps {
  onClose?(): void;
}

export const SIDE_BAR_WIDTH = '190px';

export function DoctorRoutesMenu(props: SidebarProps) {
  const isMobile = useIsMobile();
  const { isUserInvalid, prescriberId } = usePrescriberContext();

  const iconWidth = isMobile ? 40 : 20;

  return (
    <SimpleGrid w={'full'} columns={1} spacing={'10px'}>
      <SidebarButton pathTo="/inicio/receita" onClick={() => trackSideMenuPrescriptionClick(prescriberId || undefined)}>
        <Flex mr={'10px'}>
          <PillsIcon variantColor="support.blue" width={iconWidth} />
        </Flex>
        <Typography
          whiteSpace={'pre-wrap'}
          model={'body'}
          size={'normal'}
          textAlign={isMobile ? 'center' : 'left'}
          weight="bold"
        >
          Prescrição
        </Typography>
      </SidebarButton>
      {!isUserInvalid && (
        <SidebarButton pathTo="/inicio/historico" onClick={() => trackSideMenuHistoryClick(prescriberId || undefined)}>
          <Flex mr={isMobile ? 0 : '10px'} mb={isMobile ? '20px' : 0}>
            <HistoricIcon variantColor="support.blue" width={iconWidth} />
          </Flex>
          <Typography
            whiteSpace={'pre-wrap'}
            model={'body'}
            size={'normal'}
            textAlign={isMobile ? 'center' : 'left'}
            weight="bold"
          >
            Histórico
          </Typography>
        </SidebarButton>
      )}

      <SidebarButton pathTo="/inicio/meus-dados" onClick={() => trackSideMenuProfileClick(prescriberId || undefined)}>
        <Flex mr={'10px'} mb={0}>
          <DoctorIcon variantColor="support.blue" width={iconWidth} />
        </Flex>
        <Typography model={'body'} size={'normal'} textAlign={isMobile ? 'center' : 'left'} weight="bold">
          Meus dados
        </Typography>
      </SidebarButton>

      <SidebarButton
        pathTo="/inicio/convidar-assistente"
        onClick={() => trackSideMenuAssistantClick(prescriberId || undefined)}
      >
        <Flex mr={'10px'} mb={0}>
          <ShareIcon variantColor="success.light" width={iconWidth} />
        </Flex>
        <Typography model={'body'} size={'normal'} textAlign={isMobile ? 'center' : 'left'} weight="bold">
          Convidar Assistente
        </Typography>
      </SidebarButton>
    </SimpleGrid>
  );
}
